import { render, staticRenderFns } from "./blockCo.vue?vue&type=template&id=5c14968e&scoped=true&"
import script from "./blockCo.vue?vue&type=script&lang=js&"
export * from "./blockCo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c14968e",
  null
  
)

export default component.exports